import { defineNuxtPlugin } from '#app';
import { useSnippetsStore } from '~/stores/snippetsStore';

export default defineNuxtPlugin({
    name: 'snippets',
    dependsOn: ['pinia'],
    async setup(nuxtApp) {
        const snippetsStore = useSnippetsStore();
        if (!snippetsStore.initialized) {
            await snippetsStore.fetchSnippets();
        }

        // Create a proxy to handle missing snippet keys in development
        const snippetsProxy = new Proxy(snippetsStore.snippets, {
            get(target, prop) {
                if (typeof prop === 'string') {
                    // Return the actual value if it exists
                    if (prop in target) {
                        return target[prop];
                    }
                    // In development, return a placeholder for missing snippets
                    if (process.dev) {
                        return `[Missing Snippet: ${prop}]`;
                    }
                    // In production, return the key as fallback
                    return '';
                }
                return undefined;
            },
        });

        // Add `snippets` globally to the Nuxt app with the proxy wrapper
        nuxtApp.provide('snippets', snippetsProxy);
    },
});
